/* Rosas Home · Mega-menú: al pasar el mouse sobre una categoría, el panel de la
   derecha muestra los productos destacados de esa categoría.
   Horizon inyecta el mega-menú por la Section Rendering API, así que un <script>
   dentro de ese marcado nunca se ejecuta: la delegación va sobre document. */
(() => {
  if (window.__rrMegaMenuHover) return;
  window.__rrMegaMenuHover = true;

  const mostrar = (grid, clave) => {
    grid.querySelectorAll('[data-rr-mm-products]').forEach((lista) => {
      lista.hidden = lista.getAttribute('data-rr-mm-products') !== clave;
    });
  };

  /* Al abrir el menú adelantamos la carga de las fotos ocultas, para que el
     panel no salga en blanco la primera vez que se pasa por una categoría. */
  const precargar = (grid) => {
    if (grid.dataset.rrPrecargado) return;
    grid.dataset.rrPrecargado = '1';
    grid.querySelectorAll('[data-rr-mm-products] img[loading="lazy"]').forEach((img) => {
      img.setAttribute('fetchpriority', 'low');
      img.setAttribute('loading', 'eager');
    });
  };

  document.addEventListener('pointerover', (evento) => {
    const item = evento.target?.closest?.('.menu-list__list-item');
    if (item) {
      const grid = item.querySelector('.mega-menu__grid');
      if (grid) precargar(grid);
    }

    const enlace = evento.target?.closest?.('[data-rr-mm-hover]');
    if (!enlace) return;
    const grid = enlace.closest('.mega-menu__grid');
    if (!grid) return;
    const clave = enlace.getAttribute('data-rr-mm-hover');
    const destino = grid.querySelector('[data-rr-mm-products="' + clave + '"]');
    /* Si la categoría no tiene productos publicados dejamos el panel por
       defecto, en vez de mostrar un hueco vacío. */
    if (destino && destino.querySelector('li')) mostrar(grid, clave);
  });

  document.addEventListener('pointerout', (evento) => {
    const item = evento.target?.closest?.('.menu-list__list-item');
    if (!item || item.contains(evento.relatedTarget)) return;
    const grid = item.querySelector('.mega-menu__grid');
    if (grid) mostrar(grid, '__default');
  });
})();
